import moment from 'moment'

export class Entity {
  constructor(data, isDefault = false) {
    this._default = isDefault;

    Object.entries(JSON.parse(JSON.stringify(data))).forEach(([key, value]) => {
      this[key] = value;
    });
  }

  get isDefault() {
    return this._default;
  }

  get createdAtFormatted() {
    if (!this.created_at) {
      return null;
    }

    return this.formatDate(this.created_at, 'DD/MM/YYYY HH:mm');
  }

  get updatedAtFormatted() {
    if (!this.updated_at) {
      return null;
    }

    return this.formatDate(this.updated_at, 'DD/MM/YYYY HH:mm');
  }

  formatDate(date, format = 'DD/MM/YYYY') {
    return moment(date).format(format);
  }

  formatCurrency(value) {
    return value.toReal();
  }
}
